module.exports = __webpack_public_path__ + "static/media/AssignEmployeeScreen.4815eb5d.png";